/* eslint-disable */
import { APPLICATION_FORM_SERVICES, USERS_ENTITY } from '../constants/EntityName';
import { errorMsg } from '../constants/messages';
import { parametersTypeOptions } from './ApplicationFormMaster/FormServices';
import { getOptions } from './OptionService';

// Define the option type for consistency
interface OptionType {
  name: string;
  value: string | number;
  [key: string]: any;
}

const bucketFormData = [
  {
    title: 'Role Title',
    name: 'title',
    label: 'Role Title',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Role Title', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
  },

  {
    name: 'service',
    label: 'service',
    fieldType: {
      name: 'multiSelect',
      options: [],
    },
    placeholder: 'Click here to select Service',
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Service Name', allowAddRecordClick: false, columnType: 'serviceNames' },
    isTableHeader: true,
    isAccordian: true,
    readonly: false,
  },
  {
    name: 'parameters',
    label: 'Parameters',
    fieldType: {
      name: 'dynamicCountriesSelect',
      options: parametersTypeOptions,
    },
    placeholder: 'Click here to select an Parameters',
    required: true,
    errorMsg: errorMsg,
    readonly: true,
    tableMeta: {
      title: 'Parameters',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'parametersDisplayNameObject',
    },
    isTableHeader: false,
    isAccordian: true,
  },
  {
    name: 'createdAt',
    label: 'Create Bucket Date',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    readonly: true,
    tableMeta: {
      title: 'Create Bucket Date',
      enableSort: true,
      allowAddRecordClick: false,
      columnType: 'date',
    },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'updatedAt',
    label: 'Last Updated Date',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    readonly: true,
    tableMeta: {
      title: 'Last Updated Date',
      enableSort: true,
      allowAddRecordClick: false,
      columnType: 'date',
    },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'isActive',
    label: 'Is Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Is Active',
      enableSort: false,
      columnType: 'active',
    },
    isTableHeader: true,
    isAccordian: true,
    default: true,
  }
  // {
  //   name: 'adminusers',
  //   label: 'Admin Users',
  //   fieldType: {
  //     name: 'multiSelect',
  //     options: [],
  //   },
  //   placeholder: 'Click here to select Admin Users',
  //   required: true,
  //   errorMsg: errorMsg,
  //   tableMeta: { title: 'Users', allowAddRecordClick: false, columnType: 'adminusers' },
  //   isTableHeader: true,
  //   isAccordian: true,
  //   readonly: false,
  // },
];

const fetchBucketServiceOptions = async (): Promise<OptionType[]> => {
  try {
    const options = await getOptions(APPLICATION_FORM_SERVICES);
    const serviceOptions = Array.isArray(options)
      ? options
        .filter((item: any) => item?.isActive !== false)
        .map((item: any) => ({
          ...item,
          value: String(item.id),
          name: item.name,
        }))
      : [];

    const uniqueServiceOptions = serviceOptions.reduce(
      (acc: OptionType[], option: OptionType) => {
        const normalizedName = String(option.name || '').trim().toLowerCase();
        if (!normalizedName || acc.some(existing => String(existing.name).trim().toLowerCase() === normalizedName)) {
          return acc;
        }
        return [...acc, option];
      },
      []
    );

    return [...uniqueServiceOptions].reverse();
  } catch (error) {
    console.error('Error fetching bucket services:', error);
    return [];
  }
};

const fetchAndSetOptions = async (): Promise<OptionType[]> => {
  try {
    const options = await getOptions(USERS_ENTITY);
    let tempArr: OptionType[] = [];

    if (options && Array.isArray(options)) {
      options.forEach((item: any) => {
        if (item.role !== 'Super Admin') {
          tempArr.push({
            ...item,
            value: item.id,
            name: item.name,
          });
        }
      });

      console.log('Admin Users Options:', tempArr);
      return tempArr;
    }
    return [];
  } catch (error) {
    console.error('Error fetching admin users:', error);
    return [];
  }
};

export { bucketFormData, fetchAndSetOptions, fetchBucketServiceOptions };
